import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnit1 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "unit1",
	"data-name": "unit1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: -21.210165,
			y: -10.609603,
			width: 8.4899998,
			height: 21.209999,
			transform: "rotate(-135)",
			id: "rect6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 18.66,
			y1: 11,
			x2: 16.540001,
			y2: 8.8800001,
			id: "line8"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 15.83,
			y1: 13.83,
			x2: 14.41,
			y2: 12.41,
			id: "line10"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 13,
			y1: 16.66,
			x2: 10.88,
			y2: 14.54,
			id: "line12"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 10.17,
			y1: 19.49,
			x2: 8.7600002,
			y2: 18.07,
			id: "line14"
		}),
		/* @__PURE__ */ _jsx("text", {
			className: "icon-text",
			x: 1.9942058,
			y: 10.21188,
			id: "text1281",
			transform: "rotate(-45)",
			children: /* @__PURE__ */ _jsx("tspan", {
				className: "thin-stroke",
				id: "tspan1279",
				x: 1.9942058,
				y: 10.21188,
				children: "1\n        "
			})
		})
	]
});
const ForwardRef = forwardRef(SvgUnit1);
export default ForwardRef;
